<template lang="pug">
  v-card.mt-4(v-if="response" outlined)
    v-card-title
      | Response
      v-spacer
      v-chip(
        :color="getStatusColor(response.status)"
        dark
        small
        mr-2
      ) {{ response.status }}
      v-btn(icon small @click="copyResponse" aria-label="Copy response to clipboard")
        v-icon mdi-content-copy 
    v-card-text
      pre.response-body {{ formattedResponse }}
</template>

<script>
export default {
  name: 'ResponseViewer',
  props: {
    response: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      observer: null,
      intervalId: null,
    };
  },
  computed: {
    formattedResponse() {
      const data = (this.response && this.response.data) || this.response || {};
      return JSON.stringify(data, null, 2);
    },
  },
  methods: {
    getStatusColor(status) {
      if (status >= 200 && status < 300) return 'green';
      if (status >= 400 && status < 500) return 'orange';
      if (status >= 500) return 'red';
      return 'grey';
    },
    copyResponse() {
      navigator.clipboard.writeText(this.formattedResponse);
      alert('Response copied to clipboard!');
    },
  },
};
</script>

<style lang="scss" scoped>
.response-body {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.5;
  max-height: 500px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

</style>

